export const clFarmGuardAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "sender", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      { indexed: false, internalType: "uint256", name: "shares", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "amount0", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "amount1", type: "uint256" },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      { internalType: "address", name: "_ICHIVaultFactory", type: "address" },
      { internalType: "address", name: "_WRAPPED_NATIVE", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "_ICHIVaultFactory", type: "address" },
      { indexed: false, internalType: "address", name: "_WETH", type: "address" },
    ],
    name: "Deployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "sender", type: "address" },
      { indexed: true, internalType: "address", name: "vault", type: "address" },
      { indexed: true, internalType: "address", name: "token", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "shares", type: "uint256" },
      { indexed: false, internalType: "address", name: "to", type: "address" },
    ],
    name: "DepositForwarded",
    type: "event",
  },
  {
    inputs: [],
    name: "ICHIVaultFactory",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WRAPPED_NATIVE",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "vault", type: "address" },
      { internalType: "address", name: "vaultDeployer", type: "address" },
      { internalType: "address", name: "token", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "minimumProceeds", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "forwardDepositToICHIVault",
    outputs: [{ internalType: "uint256", name: "vaultTokens", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "vault", type: "address" },
      { internalType: "address", name: "vaultDeployer", type: "address" },
      { internalType: "uint256", name: "minimumProceeds", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "forwardNativeDepositToICHIVault",
    outputs: [{ internalType: "uint256", name: "vaultTokens", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "vault", type: "address" },
      { internalType: "address", name: "vaultDeployer", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "minAmount0", type: "uint256" },
      { internalType: "uint256", name: "minAmount1", type: "uint256" },
    ],
    name: "forwardNativeWithdrawFromICHIVault",
    outputs: [
      { internalType: "uint256", name: "amount0", type: "uint256" },
      { internalType: "uint256", name: "amount1", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "vault", type: "address" },
      { internalType: "address", name: "vaultDeployer", type: "address" },
      { internalType: "uint256", name: "shares", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "minAmount0", type: "uint256" },
      { internalType: "uint256", name: "minAmount1", type: "uint256" },
    ],
    name: "forwardWithdrawFromICHIVault",
    outputs: [
      { internalType: "uint256", name: "amount0", type: "uint256" },
      { internalType: "uint256", name: "amount1", type: "uint256" },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "vaultDeployer", type: "address" },
      { internalType: "address", name: "token0", type: "address" },
      { internalType: "address", name: "token1", type: "address" },
      { internalType: "uint24", name: "fee", type: "uint24" },
      { internalType: "bool", name: "allowToken0", type: "bool" },
      { internalType: "bool", name: "allowToken1", type: "bool" },
    ],
    name: "vaultKey",
    outputs: [{ internalType: "bytes32", name: "key", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  { stateMutability: "payable", type: "receive" },
] as const
